<template>
  <div>
    <!-- -------- Filters -------- -->
    <div class="row"><div class="col-12"><hr class="my-3" /></div></div>

    <div class="row d-none d-md-flex">
      <div class="col-3"><small class="text-muted">{{ $t('planned_trails.search_by_text') }}</small></div>
      <div class="col-3"><small class="text-muted">{{ $t('planned_trails.search_by_date_range') }}</small></div>
      <div class="col-3"></div><div class="col-3"></div>
    </div>

    <div class="row d-block d-md-none">
      <div class="col-12"><small class="text-muted">{{ $t('planned_trails.filter_routes') }}</small></div>
    </div>

    <div class="row">
      <div class="col-12 col-md-3 my-2">
        <input class="form-control" type="text" v-model="searchString" :placeholder="$t('planned_trails.name_or_description')" />
      </div>
      <div class="col-12 col-md-3 my-2">
        <input class="form-control" type="date" v-model="startDate" :placeholder="$t('planned_trails.start_date')" />
      </div>
      <div class="col-12 col-md-3 my-2">
        <input class="form-control" type="date" v-model="endDate" :placeholder="$t('planned_trails.end_date')" />
      </div>
      <div class="col-12 col-md-3 my-2">
        <button class="btn btn-primary btn-sm" @click="searchPlannedTrailsClicked($event, true)">{{ $t('shared.search') }}</button>
        <button class="btn btn-text btn-sm" @click="clearSearchFilters($event)">{{ $t('shared.clear') }}</button>
      </div>
    </div>

    <div class="row"><div class="col-12"><hr class="my-3" /></div></div>

    <!-- -------- List -------- -->
    <div class="bg-dark p-3 rounded-lg">
      <div v-if="plannedTrails.length">
        <div v-for="(trail,index) in plannedTrails" :key="trail.id || index">
          <div class="row">
            <a :href="trail.shareableUrl" class="col-12 col-md-2 d-flex align-items-center justify-content-center square p-1">
              <img :src="trail.thumbnailUrl" class="rounded img-fluid my-2" width="176" height="98" :alt="$t('planned_trails.planned_trail_thumbnail')" />
            </a>

            <div class="col-12 col-md-10 my-2 d-flex align-items-center justify-content-between">
              <div>
                <a :href="trail.shareableUrl"><h3 class="display-5"><b>{{ trail.title || $t('planned_trails.untitled_planned_trail') }}</b></h3></a>
                <p class="text-muted"><small>{{ formatDate(trail.createdAt) }}</small></p>
              </div>

              <!-- -------- Dropdown -------- -->
              <div class="dropdown float-end align-self-start">
                <button class="btn btn-secondary dropdown-toggle d-flex align-items-center"
                        type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="material-icons">more_vert</span>
                </button>
                <ul class="dropdown-menu">
                  <li v-if="formMode"><button class="dropdown-item" @click="selectPlannedTrail($event, trail)">{{ $t('planned_trails.select_route') }}</button></li>
                  <li><a class="dropdown-item" :href="trail.shareableUrl">{{ $t('planned_trails.view_map') }}</a></li>
                  <li><button class="dropdown-item" @click="exportGpx(trail)">{{ $t('planned_trails.export_gpx') }}</button></li>
                  <li><button class="dropdown-item" @click="showFlyover($event, trail)">{{ $t('shared.3d_flyover') }}</button></li>
                  <li><a class="dropdown-item" :href="printPlannedTrail(trail)">{{ $t('planned_trails.print_map') }}</a></li>
                  <li><button class="dropdown-item" @click="editPlannedTrail($event, trail)">{{ $t('planned_trails.edit_route') }}</button></li>
                  <li><button class="dropdown-item" @click="triggerCopyModel($event, trail)">{{ $t('planned_trails.share_route') }}</button></li>
                  <li><button class="dropdown-item" @click="deletePlannedTrail($event, trail)">{{ $t('planned_trails.delete_route') }}</button></li>
                </ul>
              </div>
              <!-- /Dropdown -->
            </div>
          </div>

          <div class="row"><div class="col-12"><hr class="my-3" /></div></div>
        </div>
      </div>
      <div v-else><p>{{ $t('planned_trails.no_hikes_found') }}</p></div>

      <div v-if="hasMoreTrails" class="see-more d-flex justify-content-center m-0">
        <button class="btn btn-link" @click="searchPlannedTrailsClicked($event, false)">{{ $t('planned_trails.see_more') }}</button>
      </div>

      <LoadingDialog :show-loading-dialog="loading" />

      <!-- -------- Share Modal -------- -->
      <div id="copyModal" class="modal fade">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header d-flex justify-content-between">
              <h3 id="linkModalLabel" class="modal-title m-0"><strong>{{ $t('shared.share') }}</strong></h3>
              <button id="close" class="close btn-link" data-bs-dismiss="modal" :aria-label="$t('shared.close')"><span>×</span></button>
            </div>
            <div class="modal-body">
              <p class="mb-1"><strong>{{ $t('planned_trails.trail_link') }}</strong> <span id="copyURLConfirmation" class="text-yellow" style="display:none">{{ $t('planned_trails.copied') }}</span></p>
              <p class="mb-3"><small class="text-muted">{{ $t('planned_trails.anyone_with_this_link_can_view') }}</small></p>

              <div class="input-group mb-3" id="copyURLInputGroup" @click="copyToClipboard">
                <input id="trailShareInput" class="form-control" type="text" />
                <button class="btn btn-primary input-group-text" type="button">
                  <span class="material-icons">content_copy</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Share Modal -->
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import graph_client from '../../utils/graphql/graph_client'
import {
  DestroyPtv2PlannedTrail,
  GetPtv2PlannedTrail } from '../../utils/graphql/planned-trail-graph'
import { SearchPtv2PlannedTrailsQuery } from '../../utils/graphql/planned-trails'
import LoadingDialog from '../../utils/shared_components/LoadingDialog.vue'
import moment from 'moment'
import { Modal, Dropdown } from 'bootstrap'

import { getFeatureCollectionLineString } from '../../utils/getFeatureCollectionLineString'
import { geojsonToGpx } from '../../utils/geojsonToGpx'
import { buildExportFileName } from '../../utils/helpers/exportFileName'

export default {
  name: 'PlannedTrails',
  components: { LoadingDialog },
  props: {
    formMode: { type: Boolean, default: false }
  },
  data () {
    return {
      plannedTrails: [],
      searchString: '',
      startDate: null,
      endDate: null,
      currentPage: 1,
      pageSize: 10,
      hasMoreTrails: false,
      loading: true,
      dropdownInstances: []
    }
  },
  mounted () {
    this.searchPlannedTrails(true)
  },
  beforeUnmount () {
    this.dropdownInstances.forEach(d => d.dispose())
    this.dropdownInstances = []
  },
  methods: {
    /* ---------- Utilities ---------- */
    formatDate (date) { return moment(date).format('LLL') },
    initializeDropdowns () {
      this.dropdownInstances.forEach(d => d.dispose())
      this.dropdownInstances = []
      const list = this.$el.querySelectorAll('[data-bs-toggle="dropdown"]')
      list.forEach(el => this.dropdownInstances.push(Dropdown.getOrCreateInstance(el)))
    },

    /* ---------- Searching ---------- */
    searchPlannedTrailsClicked (e, reset = false) { e.preventDefault(); this.searchPlannedTrails(reset) },
    searchPlannedTrails (reset = false) {
      this.loading = true
      if (reset) { this.currentPage = 1; this.plannedTrails = [] }

      const variables = {
        search: this.searchString,
        startDate: this.startDate || null,
        endDate: this.endDate || null,
        page: this.currentPage,
        pageSize: this.pageSize
      }

      graph_client.request(SearchPtv2PlannedTrailsQuery, variables)
        .then(({ ptv2PlannedTrailsTextSearch: newTrails }) => {
          this.plannedTrails = reset ? newTrails : this.plannedTrails.concat(newTrails)
          this.hasMoreTrails = newTrails.length === this.pageSize
          if (this.hasMoreTrails) this.currentPage += 1
          this.$nextTick(() => this.initializeDropdowns())
        })
        .catch(err => console.error('Error fetching planned trails:', err))
        .finally(() => { this.loading = false })
    },
    clearSearchFilters (e) {
      e.preventDefault()
      this.searchString = ''; this.startDate = null; this.endDate = null
      this.searchPlannedTrails(true)
    },

    /* ---------- Actions ---------- */
    selectPlannedTrail (e, trail) {
      e.preventDefault()
      window.trailSelected(trail.id)
      window.trailSelectedName(trail.title)
      window.closeVueModal()
    },
    editPlannedTrail (e, trail) { e.preventDefault(); window.location = `${trail.shareableUrl}/edit` },
    printPlannedTrail (trail) { return `/print-maps?data_ids[]=${trail.id}&data_types[]=Ptv2::PlannedTrail` },
    showFlyover (e, trail) {
      e.preventDefault()
      window.showMapModalForPlannedTrail
        ? window.showMapModalForPlannedTrail(trail.id)
        : console.error('showMapModalForPlannedTrail not found')
    },
    deletePlannedTrail (e, trail) {
      e.preventDefault()
      if (!confirm(this.$t('planned_trails.delete_confirm'))) return
      this.loading = true
      graph_client.request(DestroyPtv2PlannedTrail, { plannedTrail: { id: trail.id } })
        .then(() => this.searchPlannedTrails(true))
        .catch(err => { console.error('Error deleting planned trail:', err); this.loading = false })
    },
    triggerCopyModel (e, trail) {
      e.preventDefault()
      this.$nextTick(() => {
        const input = document.getElementById('trailShareInput')
        const modalEl = document.getElementById('copyModal')
        if (!input || !modalEl) return console.error('Share modal elements not found')
        input.value = trail.shareableUrl
        Modal.getOrCreateInstance(modalEl).show()
      })
    },
    copyToClipboard () {
      const input = document.getElementById('trailShareInput')
      if (!input) return
      input.select(); input.setSelectionRange(0, 99999)
      navigator.clipboard.writeText(input.value).then(() => {
        const conf = document.getElementById('copyURLConfirmation')
        if (conf) { conf.style.display = 'inline'; setTimeout(() => { conf.style.display = 'none' }, 2000) }
      }).catch(err => console.error('Failed to copy text:', err))
    },

    /* ---------- NEW: GPX Export ---------- */
    async exportGpx (trail) {
      try {
        const { ptv2PlannedTrailById: planned } = await graph_client.request(GetPtv2PlannedTrail, { id: trail.id })

        // Build coordinate array from stored FeatureCollection
        const geojson = planned.geojsonFeatureCollection;
        const coords = getFeatureCollectionLineString(geojson)

        const gpx = geojsonToGpx(
          {
            type: 'Feature',
            properties: {},
            geometry: { type: 'LineString', coordinates: coords }
          },
          null, // planned trails don’t have timestamps
          {
            creator: 'Hiiker',
            metadata: { name: planned.title, time: planned.createdAt }
          }
        )

        const blob = new Blob([gpx], { type: 'application/gpx+xml' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = buildExportFileName(planned.title, 'gpx')
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      } catch (err) {
        console.error('Error exporting GPX:', err)
        alert(this.$t('planned_trails.gpx_export_failed'))
      }
    }
  }
}
</script>

<style scoped>
.dropdown-toggle::after { display: none; }
.see-more { margin-top: 20px; }
.see-more button { padding: 10px 20px; font-size: 16px; }
</style>
